import { AirportCodes } from '../../../../types/airports';

export const getParkingAvailabilityPercentageData = (
	totalSpots: number | null,
	occupiedSpots: number | null,
	airportCode: AirportCodes,
	hadOverrideStatus: boolean,
) => {
	if (totalSpots === null || occupiedSpots === null) {
		return { number: 0, remark: 'Data unavailable' };
	}

	if (hadOverrideStatus) {
		return { number: 3, remark: 'Alert' };
	}
	const percentage = (occupiedSpots / totalSpots) * 100;

	const notAvailable = { number: 0, remark: 'Not available' };

	if (percentage === 0) {
		return notAvailable;
	}

	// Calculate amount of icons to fill

	const one = percentage >= 0 && percentage < 84;
	const two =
		airportCode === AirportCodes.IAH
			? percentage > 83 && percentage < 91
			: percentage > 83 && percentage < 96;
	const three =
		airportCode === AirportCodes.IAH
			? percentage > 89 && percentage < 101
			: percentage > 94 && percentage < 101;

	if (one)
		return {
			number: 1,
			remark: `${Math.round(percentage)}% full`,
		};
	if (two)
		return {
			number: 2,
			remark: `${Math.round(percentage)}% full`,
		};
	if (three)
		return {
			number: 3,
			remark: `${Math.round(percentage)}% full`,
		};
	return notAvailable;
};
